import 'animate.css';
import '@urbanx/agx-ui-components/dist/index.css';
import '@urbanx/agx.ui-components2/dist/agx.ui-components2.css';
import './App.scss';

import { useEffect, useMemo } from 'react';
import { RouterProvider } from 'react-router-dom';
import { useAppSelector } from 'hooks/useAppSelector';

import { Popup } from './components/ui-components';
import { AgxToast } from '@urbanx/agx-ui-components';
import { Widget } from './components/freshDeskWidget/freshDeskWidget';
import LogRocket from 'logrocket';

import { AgxDialogProvider, AgxToasts } from '@urbanx/agx.ui-components2';
import { AgxAuth } from '@urbanx/agx.auth.client';
import AppConfig from './config/AppConfig';
import ApiProvider from './Api/ApiProvider';
import router from './router';

function App() {
  const { toast: toastState } = useAppSelector((state) => state.config);

  const isLocal = useMemo(() => {
    return window.location.hostname === 'localhost';
  }, []);

  useEffect(() => {
    if (isLocal) return;
    LogRocket.init('dzljjh/autopilot');
  }, []);

  return (
    <AgxToasts>
      <AgxAuth apiConfig={AppConfig}>
        <ApiProvider>
          <AgxToast selector="#toast" toastState={toastState} />
          <AgxDialogProvider>
            <Popup selector="#popup" />
            <RouterProvider router={router} />
            {!isLocal && <Widget />}
          </AgxDialogProvider>
        </ApiProvider>
      </AgxAuth>
    </AgxToasts>
  );
}

export default App;
